import { useQueryClient as o, useMutation as n, useQuery as d } from "@tanstack/react-query";
import a from "./transcripts.api.js";
import { teachurKeys as c } from "../../constants/teachurKeys.js";
const v = (e) => d({
  queryKey: c.transcripts.evaluation(),
  queryFn: async () => (await a.getEvaluation()).data,
  retry: !1,
  ...e
}), T = (e) => d({
  queryKey: c.transcripts.list(),
  queryFn: async () => (await a.listTranscripts()).data,
  ...e
}), p = (e) => {
  e.invalidateQueries({ queryKey: c.transcripts.evaluation() }), e.invalidateQueries({ queryKey: c.transcripts.list() });
}, F = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.updatePersonalInfo(t)).data,
    onSuccess: (t) => {
      s.setQueryData(c.transcripts.evaluation(), t);
    },
    meta: {
      successMessage: "Personal information saved",
      errorMessage: "Failed to save personal information"
    },
    ...e
  });
}, g = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.updateAcademicInfo(t)).data,
    onSuccess: (t) => {
      s.setQueryData(c.transcripts.evaluation(), t);
    },
    meta: {
      successMessage: "Academic information saved",
      errorMessage: "Failed to save academic information"
    },
    ...e
  });
}, w = (e) => n({
  mutationFn: async (s) => (await a.evaluateFile(s)).data,
  meta: {
    successMessage: "Transcript extracted",
    errorMessage: "Transcript extraction failed"
  },
  ...e
}), q = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.addFileTranscript(t)).data,
    onSuccess: () => p(s),
    meta: { successMessage: "Transcript added", errorMessage: "Failed to add transcript" },
    ...e
  });
}, C = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.addManualTranscript(t)).data,
    onSuccess: () => p(s),
    meta: { successMessage: "Transcript added", errorMessage: "Failed to add transcript" },
    ...e
  });
}, S = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.updateTranscript(t, r)).data,
    onSuccess: () => p(s),
    meta: { successMessage: "Transcript updated", errorMessage: "Failed to update transcript" },
    ...e
  });
}, f = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.deleteTranscript(t)).data,
    onSuccess: () => p(s),
    meta: { successMessage: "Transcript removed", errorMessage: "Failed to remove transcript" },
    ...e
  });
}, A = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.markTranscriptReady(t)).data,
    onSuccess: () => p(s),
    meta: {
      successMessage: "Transcript marked ready for review",
      errorMessage: "Failed to mark transcript ready"
    },
    ...e
  });
}, u = (e) => {
  e.invalidateQueries({ queryKey: c.transcripts.all });
}, E = (e, s) => d({
  queryKey: c.transcripts.evaluations(e),
  queryFn: async () => (await a.listEvaluations(e)).data,
  keepPreviousData: !0,
  ...s
}), Q = (e, s) => d({
  queryKey: c.transcripts.evaluationDetail(e),
  queryFn: async () => (await a.getEvaluationAdmin(e)).data,
  enabled: !!e,
  ...s
}), D = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.reviewTranscript(t, r)).data,
    onSuccess: () => u(s),
    meta: {
      successMessage: "Transcript reviewed",
      errorMessage: "Failed to review transcript"
    },
    ...e
  });
}, K = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.saveTranscriptProgress(t, r)).data,
    onSuccess: () => u(s),
    meta: {
      successMessage: "Progress saved",
      errorMessage: "Failed to save progress"
    },
    ...e
  });
}, P = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ userId: t, body: r }) => (await a.adminAddTranscript(t, r)).data,
    onSuccess: () => u(s),
    meta: { successMessage: "Transcript added", errorMessage: "Failed to add transcript" },
    ...e
  });
}, k = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, formData: r }) => (await a.validateTranscript(t, r)).data,
    onSuccess: () => u(s),
    meta: { errorMessage: "Transcript validation failed" },
    ...e
  });
}, R = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.replaceTranscriptCourses(t, r)).data,
    onSuccess: () => u(s),
    meta: { successMessage: "Courses saved", errorMessage: "Failed to save courses" },
    ...e
  });
}, G = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.reorderTranscriptCourses(t, r)).data,
    onSuccess: () => u(s),
    meta: { errorMessage: "Failed to reorder courses" },
    ...e
  });
}, I = (e) => {
  const s = o();
  return n({
    mutationFn: async (t) => (await a.deleteTranscript(t)).data,
    onSuccess: () => u(s),
    meta: { successMessage: "Transcript deleted", errorMessage: "Failed to delete transcript" },
    ...e
  });
}, U = (e) => {
  const s = o();
  return n({
    mutationFn: async ({ id: t, body: r }) => (await a.updateTranscriptDetails(t, r)).data,
    onSuccess: () => u(s),
    meta: {
      successMessage: "Transcript details saved",
      errorMessage: "Failed to save transcript details"
    },
    ...e
  });
}, x = (e) => {
  const s = o();
  return n({
    mutationFn: async ({
      transcriptId: t,
      transcriptFileId: r,
      body: i
    }) => (await a.processTranscriptFile(
      t,
      r,
      i
    )).data,
    onSuccess: () => u(s),
    meta: {
      successMessage: "Transcript created",
      errorMessage: "Failed to process document"
    },
    ...e
  });
};
export {
  q as useAddFileTranscriptMutation,
  C as useAddManualTranscriptMutation,
  P as useAdminAddTranscriptMutation,
  I as useAdminDeleteTranscriptMutation,
  f as useDeleteTranscriptMutation,
  w as useEvaluateFileMutation,
  Q as useGetAdminEvaluationQuery,
  E as useGetAdminEvaluationsQuery,
  v as useGetEvaluationQuery,
  T as useGetTranscriptsQuery,
  A as useMarkTranscriptReadyMutation,
  x as useProcessTranscriptFileMutation,
  G as useReorderTranscriptCoursesMutation,
  R as useReplaceTranscriptCoursesMutation,
  D as useReviewTranscriptMutation,
  K as useSaveTranscriptProgressMutation,
  g as useUpdateEvaluationAcademicInfoMutation,
  F as useUpdateEvaluationPersonalInfoMutation,
  U as useUpdateTranscriptDetailsMutation,
  S as useUpdateTranscriptMutation,
  k as useValidateTranscriptMutation
};
